import { render, staticRenderFns } from "./EstimateObjectStatistic.vue?vue&type=template&id=73060c64&"
import script from "./EstimateObjectStatistic.vue?vue&type=script&lang=js&"
export * from "./EstimateObjectStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports